'use strict';

class SvgCommon {
	constructor(props = {}) {
		console.log('SvgCommon::constructor(%o)', props);
		let _that = this;

		_that = Object.assign(this, props);

		_that.cloneContent('', '');
	}

	cloneContent(svg_id, new_svg_id) {
		if (!svg_id || !new_svg_id) {
			return null;
		}
		let new_element = document.getElementById(svg_id);
		if (new_element) {
			new_element = new_element.cloneNode(true);
			new_element.setAttribute('id', new_svg_id);

			return new_element;
		}
	}
}
